import { ILondonProtocol } from 'types/notification'
import { convertToDateObject, stringToDate } from 'utils/dateUtils'

export const getLabelByValue = (data: any[], key: string, value: string) => {
    const foundLabel = data?.find((item) => item[key] === value)
    return foundLabel?.description || foundLabel?.label
}
export const getFactorLabels = (data: string, mainObject: any[]) => {
    if (!data || !mainObject || !mainObject.length) return
    const parsedList = parseListFromString(data)
    const labelList = parsedList
        .map((item) => {
            const label = getLabelByValue(mainObject, 'sys_id', item)
            return label
        })
        .filter((item) => item)
    return labelList.join('; ')
}
export const parseFromString = (data: string) => {
    if (!data) return
    const dataWithoutBrackets = data.slice(1, -1)
    const parsedList = dataWithoutBrackets.split(',')
    return parsedList.join(', ')
}
export const parseListFromString = (data: string) => {
    if (!data) return
    const dataWithoutBrackets = data.slice(1, -1)
    const parsedList = dataWithoutBrackets.split(',')
    return parsedList.map(p => p.trim())
}

export const stepThreeFiledNames = [
    'u_patient_care_number',
    'patients_health_insurance',
    'date_of_patient_admission',
    'types_of_diagnosis',
    'event_investigation_team',
    'probability',
    'tolerability_analysis',
    'oms_classification',
    'sentinel_event',
    'organizational_consequences',
    'chronological_report',
    'patient_factors',
    'u_patient_factors_description',
    'task_factors_and_technology',
    'u_task_factors_and_technology_description',
    'individual_factors_people',
    'u_individual_factors_people_description',
    'team_factors_teams',
    'u_team_factors_teams_description',
    'work_environment_factors',
    'u_work_environment_factors_description',
    'organizational_and_managerial_factors',
    'u_organizational_and_managerial_factors_description',
    'institutional_context_factors',
    'u_institutional_context_factors_description'
]
interface SetStarterDataProps {
    setValue: any
    data: ILondonProtocol
}
export const setStartedDataCommon = ({
    setValue,
    data
}: SetStarterDataProps) => {
    const dateAdmission = convertToDateObject(data?.date_of_patient_admission)
    setValue('u_patient_care_number', data.u_patient_care_number)
    setValue('patients_health_insurance', data.patients_health_insurance)
    setValue('date_of_patient_admission', dateAdmission ? dateAdmission : '')
    setValue('types_of_diagnosis', data.types_of_diagnosis?.value)
    setValue('event_investigation_team', data.event_investigation_team)
    setValue('probability', data.probability)
    setValue('tolerability_analysis', data.tolerability_analysis)
    setValue('organizational_consequences', data.organizational_consequences)
    setValue('chronological_report', data.chronological_report)
    setValue('patient_factors', parseListFromString(data.patient_factors))
    setValue(
        'u_patient_factors_description',
        data.u_patient_factors_description
    )
    setValue(
        'task_factors_and_technology',
        parseListFromString(data.task_factors_and_technology)
    )
    setValue(
        'u_task_factors_and_technology_description',
        data.u_task_factors_and_technology_description
    )
    setValue(
        'individual_factors_people',
        parseListFromString(data.individual_factors_people)
    )
    setValue(
        'u_individual_factors_people_description',
        data.u_individual_factors_people_description
    )
    setValue('team_factors_teams', parseListFromString(data.team_factors_teams))
    setValue(
        'u_team_factors_teams_description',
        data.u_team_factors_teams_description
    )
    setValue(
        'work_environment_factors',
        parseListFromString(data.work_environment_factors)
    )
    setValue(
        'u_work_environment_factors_description',
        data.u_work_environment_factors_description
    )
    setValue(
        'organizational_and_managerial_factors',
        parseListFromString(data.organizational_and_managerial_factors)
    )
    setValue(
        'u_organizational_and_managerial_factors_description',
        data.u_organizational_and_managerial_factors_description
    )
    setValue(
        'institutional_context_factors',
        parseListFromString(data.institutional_context_factors)
    )
    setValue(
        'u_institutional_context_factors_description',
        data.u_institutional_context_factors_description
    )
}

export const setStartedDataV1 = ({ setValue, data }: SetStarterDataProps) => {
    setStartedDataCommon({ setValue, data })
    setValue('sentinel_event', data.sentinel_event?.value)
}

export const setStartedDataV2 = ({ setValue, data }: SetStarterDataProps) => {
    setStartedDataCommon({ setValue, data })
    setValue(
        'u_strengths_of_the_care_provided_and_problems_in_managing_care',
        data.u_strengths_of_the_care_provided_and_problems_in_managing_care
    )
    setValue('u_data_source_and_methods', data.u_data_source_and_methods)
    setValue(
        'u_technology_and_electronic_information_systems',
        parseListFromString(
            data.u_technology_and_electronic_information_systems
        )
    )
    setValue(
        'u_description_technology_and_electronic_information_systems',
        data.u_description_technology_and_electronic_information_systems
    )
    setValue(
        'u_support_for_patients_families_and_staff',
        parseListFromString(data.u_support_for_patients_families_and_staff)
    )
    setValue(
        'u_description_support_for_patients_families_and_staff',
        data.u_description_support_for_patients_families_and_staff
    )
    setValue('u_nsp_opinion', data.u_nsp_opinion)
    setValue('u_description_nsp_opinion', data.u_description_nsp_opinion)
}

export const setStartedDataV3 = ({ setValue, data }: SetStarterDataProps) => {
    setStartedDataCommon({ setValue, data })
    setValue(
        'u_strengths_of_the_care_provided_and_problems_in_managing_care',
        data.u_strengths_of_the_care_provided_and_problems_in_managing_care
    )
    setValue('u_data_source_and_methods', data.u_data_source_and_methods)
    setValue(
        'u_technology_and_electronic_information_systems',
        parseListFromString(
            data.u_technology_and_electronic_information_systems
        )
    )
    setValue(
        'u_description_technology_and_electronic_information_systems',
        data.u_description_technology_and_electronic_information_systems
    )
    setValue(
        'u_support_for_patients_families_and_staff',
        parseListFromString(data.u_support_for_patients_families_and_staff)
    )
    setValue(
        'u_description_support_for_patients_families_and_staff',
        data.u_description_support_for_patients_families_and_staff
    )
    setValue('u_nsp_opinion', data.u_nsp_opinion)
    setValue('u_description_nsp_opinion', data.u_description_nsp_opinion)
}
